import * as React from 'react';
import { messages, allEvents } from '../../messages';
import { useLocalization } from '@progress/kendo-react-intl';
/** @hidden */
export var TimelineViewAllEventsRowContent = function (props) {
    var localization = useLocalization();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "k-sticky-cell" },
            React.createElement("div", { className: "k-scheduler-cell k-heading-cell k-side-cell k-scheduler-times-all-day", "data-range-index": 0 }, localization.toLanguageString(allEvents, messages[allEvents]))),
        props.children));
};
